import { HStack } from "@chakra-ui/react";
import FilterButton from "components/Button/FilterButton";
import { FiList, FiCircle, FiAlertTriangle, FiUser, FiCalendar } from "react-icons/fi";
import type { QuickFilter } from "../helpers";

interface Props {
  value: QuickFilter;
  onChange: (filter: QuickFilter) => void;
  counts?: Partial<Record<QuickFilter, number>>;
}

const FILTERS: Array<{ key: QuickFilter; label: string; icon: React.ComponentType }> = [
  { key: "all", label: "All", icon: FiList },
  { key: "open", label: "Open", icon: FiCircle },
  { key: "overdue", label: "Overdue", icon: FiAlertTriangle },
  { key: "due_within_3_days", label: "Due soon", icon: FiCalendar },
  { key: "mine", label: "My Tasks", icon: FiUser },
];

export default function QuickFilters({ value, onChange, counts }: Props) {
  return (
    <HStack spacing={1.5}>
      {FILTERS.map((f) => {
        const count = counts?.[f.key];
        const label = count != null && f.key !== "all" ? `${f.label} (${count})` : f.label;
        return (
          <FilterButton
            key={f.key}
            icon={f.icon}
            isActive={value === f.key}
            onClick={() => onChange(f.key)}
            size="sm"
          >
            {label}
          </FilterButton>
        );
      })}
    </HStack>
  );
}
